__turbopack_context__.v({
  "label": "yB3Hka_label",
  "root": "yB3Hka_root",
});
